import $ from 'wee-dom';
import $mediator from 'wee-mediator';
import { _win } from 'core/variables';
import { active } from '../../scripts/classes';
import { mobile } from '../../scripts/ua';

export default class {
    constructor() {
        this.$location = $(':locationAddress');
        this.$listViewButton = $(':listViewButton');
        this.layout = $(':locationsLayout');
        this.$mapViewButton = $(':mapViewButton');
        this.mapActive = '-map-active';
        this.mapView = 'locations-map-active';
        this.markers = [];

        $mediator.on('change.view', (el) => {
            const $el = $(el);

            if (! $el.hasClass(active)) {
                $(':locationView').removeClass(active);
                $el.addClass(active);
            }

            this.toggleView();
        });

        if (mobile) {
            this.$listViewButton.addClass(active);
            this.$mapViewButton.removeClass(active);
        } else {
            this.$listViewButton.removeClass(active);
            this.$mapViewButton.addClass(active);
        }
    }

    toggleView() {
        if (this.$listViewButton.hasClass(active)) {
            this.layout.removeClass(this.mapActive);
        } else if (this.$mapViewButton.hasClass(active)) {
            this.layout.addClass(this.mapActive);
        }
    }

    getQueryParam() {
        const str = _win.location.search;
        const param = str.match(/category=([^&]*)/);
        const category = str.length ? param[1] : 'location';

        return this.filterLocations(category);
    }

    // eslint-disable-next-line class-methods-use-this
    filterLocations(category) {
        const locations = [];

        $(':location').each((el) => {
            const $el = $(el);

            if ($el.data('category') !== category && category !== 'location') {
                $el.hide();
            } else {
                const $address = $el.find('address');

                const location = {
                    selector: $el,
                    address: $address.html(),
                    data: $address.data(),
                    phone: $el.find('.js-phone'),
                    url: $el.find(':locationUrl').attr('href')
                };

                locations.push(location);
                $el.show();
            }
        });

        return locations;
    }
}
